// @flow
import { httpGet, httpPost } from '../helpers/helpers.api';

export function setAllowAnalyticsSharing(userId: string, allowAnalyticsSharing: boolean): Promise<Response> {
    return httpPost(`user/${userId}/set-media`, { allowAnalyticsSharing });
}

export function setPin(userId: string, pin: string): Promise<Response> {
    return httpPost(`user/${userId}/set-pin`, { pin });
}

export function getAttribute(userId: string, attribute: string): Promise<Response> {
    return httpGet(`web/user/${userId}/attributes/${attribute}`);
}

export function setAttribute(userId: string, attribute: string, settingsData: Object): Promise<Response> {
    return httpPost(`web/user/${userId}/attributes/${attribute}`, settingsData);
}

export function getAlerts(userId: string): Promise<Response> {
    return httpPost(`user/${userId}/get-alerts`);
}

export function setAlerts(userId: string, alerts: Object): Promise<Response> {
    return httpPost(`user/${userId}/set-alerts`, alerts);
}



// WEBPACK FOOTER //
// ./src/core/api/user/user.api.js